import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CapacityPlanDeliveriesQueryVariables = Types.Exact<{
  runId: Types.Scalars['ID'];
  page: Types.Scalars['Int'];
  pageSize: Types.Scalars['Int'];
  filter: Types.CapacityPlanDeliveryFilter;
}>;


export type CapacityPlanDeliveriesQuery = { __typename?: 'Query', capacityPlanDeliveries: { __typename?: 'CapacityPlanDeliveriesPage', totalCount: number, page: number, pageSize: number, items: Array<{ __typename?: 'CapacityPlanDelivery', id: any, rowNumber: number, address?: string | null, town?: string | null, village?: string | null, county?: string | null, deliveryId?: string | null, latitude?: number | null, longitude?: number | null, depotIndex?: number | null, hasRecipientPhone: boolean, validationError?: string | null, geocodeStatus: Types.CapacityPlanGeocodeStatus, isApproximated: boolean, geocodeError?: string | null, outOfCountry: boolean }> } };


export const CapacityPlanDeliveriesDocument = gql`
    query CapacityPlanDeliveries($runId: ID!, $page: Int!, $pageSize: Int!, $filter: CapacityPlanDeliveryFilter!) {
  capacityPlanDeliveries(
    runId: $runId
    page: $page
    pageSize: $pageSize
    filter: $filter
  ) {
    items {
      id
      rowNumber
      address
      town
      village
      county
      deliveryId
      latitude
      longitude
      depotIndex
      hasRecipientPhone
      validationError
      geocodeStatus
      isApproximated
      geocodeError
      outOfCountry
    }
    totalCount
    page
    pageSize
  }
}
    `;

/**
 * __useCapacityPlanDeliveriesQuery__
 *
 * To run a query within a React component, call `useCapacityPlanDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityPlanDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityPlanDeliveriesQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCapacityPlanDeliveriesQuery(baseOptions: Apollo.QueryHookOptions<CapacityPlanDeliveriesQuery, CapacityPlanDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapacityPlanDeliveriesQuery, CapacityPlanDeliveriesQueryVariables>(CapacityPlanDeliveriesDocument, options);
      }
export function useCapacityPlanDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapacityPlanDeliveriesQuery, CapacityPlanDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapacityPlanDeliveriesQuery, CapacityPlanDeliveriesQueryVariables>(CapacityPlanDeliveriesDocument, options);
        }
export type CapacityPlanDeliveriesQueryHookResult = ReturnType<typeof useCapacityPlanDeliveriesQuery>;
export type CapacityPlanDeliveriesLazyQueryHookResult = ReturnType<typeof useCapacityPlanDeliveriesLazyQuery>;
export type CapacityPlanDeliveriesQueryResult = Apollo.QueryResult<CapacityPlanDeliveriesQuery, CapacityPlanDeliveriesQueryVariables>;